import { makeStyles } from '@material-ui/core';
import themes from 'styles/themes';

export const useStyles = makeStyles(() => ({
    filterWrap: {
        paddingBottom: 3,
    },
    searchForm: {
        marginTop: 0,
        top: 56,
        position: 'absolute',
        left: 0,
        right: 0,
        padding: '18px 24px 0 ',
        '@media (max-width: 1024px)': {
            position: 'fixed',
        },
    },

    searchWrap: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        padding: '0 24px',
        marginBottom: '8px',
        boxSizing: 'border-box',
    },

    searchIcon: {
        position: 'absolute',
        left: 10,
        top: 2,
        color: themes.palette.primary.main,
    },

    input: {
        padding: '3px 0 3px 30px',
        background: 'transparent',
        border: 'none',
        borderBottom: `1px solid ${themes.palette.grey['300']}`,
        color: themes.palette.primary.main,
        fontSize: 14,
        position: 'relative',
        borderRadius: 0,
        outline: 'none !important',
    },
    filter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        // marginBottom: 10
    },
    filterSwiperWrapper: {
        display: 'flex',
        flex: 1,
        width: '100%',
        overflowX: 'auto',
        // '& .swiper-container': {
        //     margin: 0,
        //     width: '100%',
        //     '& .swiper-wrapper .swiper-slide': {
        //         flex: 1,
        //         width: 'auto !important',
        //     }
        // }
    },
    firstFilterChipWrap: {
        paddingLeft: 0,
        paddingRight: '6px',
        flex: 1,
        '& .MuiChip-root': {
            width: '100%',
            flexDirection: 'row-reverse',
            display: 'flex',
            padding: '0 8px',
        },
    },
    filterChipWrap: {
        paddingLeft: '6px',
        paddingRight: '6px',
        flex: 1,
        '& .MuiChip-root': {
            width: '100%',
            flexDirection: 'row-reverse',
            display: 'flex',
            padding: '0 8px',
        },
    },
    chipActive: {
        backgroundColor: `${themes.palette.primary.main} !important`,
        border: 'none !important',
        '&.MuiChip-clickable.MuiChip-outlined:hover': {
            backgroundColor: `${themes.palette.primary.main} !importnat`,
        },
        '&.MuiChip-clickable.MuiChip-outlined:focus': {
            backgroundColor: `${themes.palette.primary.main} !importnat`,
        },
    },
    chipOutline: {
        border: `1px solid ${themes.palette.grey['300']}`,
    },
    chipFilterOutline: {
        border: `1px solid ${themes.palette.grey['300']}`,
        height: 32,
        width: 32,
    },
    badgeFilter: {
        '& > span': {
            position: 'relative',
            transform: 'none !important',
            marginRight: '6px',
            background: themes.palette.common.white,
            color: themes.palette.primary.main,
        },
    },
    chipLabel: {
        color: themes.palette.primary.main,
        fontFamily: 'PoppinsRegular',
        fontSize: 12,
        fontWeight: 600,
        '&.MuiChip-label': {
            padding: 0,
        },
    },
    chipFilterLabel: {
        display: 'none',
    },
    chipLabelActive: {
        color: themes.palette.common.white,
        fontFamily: 'PoppinsRegular',
        fontSize: 12,
        fontWeight: 600,
        '&.MuiChip-label': {
            padding: 0,
        },
    },
    chipIcon: {
        color: themes.palette.primary.main,
    },
    chipFilterIcon: {
        color: 'white',
        margin: '0 !important',
    },
    chipIconActive: {
        color: themes.palette.common.white,
    },
    pageOption: {
        margin: 0,
    },
    boxOption: {
        padding: '8px 12px',
        '&:hover': {
            background: '#CCC',
        },
    },
    dropDown: {
        position: 'absolute',
        top: '100%',
        width: '100%',
        overflowY: 'scroll',
        background: '#FFF',
        borderRadius: '8px',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    },
}));
